import { useMutation } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type {
  DraftCollectionEmailInput,
  DraftCollectionEmailOutput,
} from '@erp/rpc';

/**
 * Trigger AI generation of a collection-thread email draft. The mutation
 * returns the persisted draft id (use `useEmailDraft` to read it back) plus
 * the classification — populated for `auto` runs, null for `manual` runs.
 */
export function useDraftArCollectionEmail() {
  return useMutation(
    orpc.accountsReceivable.arCollectionEmailDrafts.draft.mutationOptions(),
  ) satisfies ReturnType<
    typeof useMutation<
      DraftCollectionEmailOutput,
      Error,
      DraftCollectionEmailInput
    >
  >;
}
